import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toggleTheme } from "./Features/CommonSlice";
import { getSubscriptionById } from "./services/paymentService";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const toastobj = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
};

export const giftcarddetails = {
  sendto: "",
  sendemail: "",
  message: "",
  comment: "",
  sender: "",
  deliverdate: "",
  amount: 0,
  selamount: 0,
  cardholdername: "",
  cardmonth: "",
  cardyear: "",
  cardnumber: "",
  cvv: "",
  paymentemail: "",
  discount: 0,
  discountcode: "",
  isdiscountcode: false,
};

export const card_number = (num) => {
  if (!num) return "";

  let trimmed = num.replace(/\s+/g, "");
  if (trimmed.length > 20) {
    trimmed = trimmed.substr(0, 20);
  }

  let numbers = [];
  for (let i = 0; i < trimmed.length; i += 4) {
    numbers.push(trimmed.substr(i, 4));
  }
  return numbers.join(" ");
};

export const getcardnumberforapi = (num) => {
  return num.split(" ").join("");
};

export const analyzeslidermark = [
  { value: 0, label: "Insignificant" },
  { value: 25, label: "" },
  { value: 50, label: "Neutral" },
  { value: 75, label: "" },
  { value: 100, label: "Very Important" },
];
export const analyzeslidervived = [
  { value: 0, label: "Really Hazy" },
  { value: 25, label: "" },
  { value: 50, label: "Neutral" },
  { value: 75, label: "" },
  { value: 100, label: "Very Vivid" },
];

export const trimvalue = (val) => {
  if (val) {
    let trimval = val.replace(/[\r\n]{2,}/g, "\n");
    let arr = trimval.split("\n");
    return arr;
  } else {
    return [];
  }
};

export const RoundButton = ({ type, onClick, filled }) => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  let buttonClasses = filled
    ? `${type}FilledButton${darkMode ? "-dark" : "-light"} roundButton${
        darkMode ? "-dark" : "-light"
      }`
    : `${type}OutlinedButton${darkMode ? "-dark" : "-light"} roundButton${
        darkMode ? "-dark" : "-light"
      }`;
  return (
    <button className={buttonClasses} onClick={onClick}>
      {type === "forward" ? ">" : "<"}
    </button>
  );
};
export const RoundButtonDark = ({ type, onClick, filled }) => {
  // const darkMode = useSelector((state) => state.theme.darkMode);
  let buttonClasses = filled
    ? `${type}FilledButton-dark roundButton-dark `
    : `${type}OutlinedButton-dark roundButton-dark `;
  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      style={{ color: "white" }}
    >
      {type === "forward" ? ">" : "<"}
    </button>
  );
};
export const RoundButtonLight = ({ type, onClick, filled }) => {
  // const darkMode = useSelector((state) => state.theme.darkMode);
  let buttonClasses = filled
    ? `${type}FilledButton-dark roundButton-light `
    : `${type}OutlinedButton-dark roundButton-light `;
  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      style={{ border: "1px solid #8850FF" }}
    >
      {type === "forward" ? (
        <FontAwesomeIcon icon={faChevronRight} />
      ) : (
        <FontAwesomeIcon icon={faChevronLeft} />
      )}
    </button>
  );
};
export const BoxSmall = ({ imageSrc, singleLineText, multiLineText }) => {
  return (
    <div
      className={`box-small flexColStart ${
        window.innerWidth < 600 ? "rg-05" : "rg-1"
      }`}
    >
      <img src={imageSrc} alt="Box" className="box-image" />
      <div className="single-line-text">{singleLineText}</div>
      <p className="multi-line-text color-grey">{multiLineText}</p>
    </div>
  );
};
export const BoxLarge = ({ titleText, subTitleText, multiLineText }) => {
  return (
    <div
      className={`box-large flexColStart ${
        window.innerWidth <= 600 ? "rg-05" : "rg-1"
      }`}
    >
      <div>
        <div className="title-text">{titleText}</div>
        <div className="sub-title-text color-grey">{subTitleText}</div>
      </div>
      <p
        className="multi-line-text "
        style={{ color: "var(--text-color-black)" }}
      >
        {multiLineText}
      </p>
    </div>
  );
};

export const ButtonSolid = ({ text, onClick, width }) => {
  return (
    <button className="solid-button" onClick={onClick} style={{ width: width }}>
      {text}
    </button>
  );
};

const fontOptions2 = [
  {
    id: 1,
    label: "Red Hat Display ",
    family: "Red Hat Display, sans-serif",
    weight: "400",
    style: "",
  },
  {
    id: 2,
    label: "Red Hat Display ",
    family: "Red Hat Display, sans-serif",
    weight: "700",
    style: "",
  },
  {
    id: 3,
    label: "Red Hat Display",
    family: "Red Hat Display, sans-serif",
    weight: "400",
    style: "italic",
  },
  {
    id: 4,
    label: "monospace",
    family: "Space Mono, monospace",
    weight: "400",
    style: "",
  },
  {
    id: 5,
    label: "Red Hat Display ",
    family: "Red Hat Display, sans-serif",
    weight: "700",
    style: "italic",
  },
  {
    id: 6,
    label: "Parisienne",
    family: "Parisienne, cursive",
    weight: "400",
    style: "",
  },
  {
    id: 7,
    label: "Cormorant Garamond",
    family: "Cormorant Garamond, serif",
    weight: "400",
    style: "",
  },
  {
    id: 8,
    label: "Cormorant Garamond",
    family: "Cormorant Garamond, serif",
    weight: "400",
    style: "italic",
  },
  {
    id: 9,
    label: "Red Hat Display Light",
    family: "Red Hat Display, sans-serif",
    weight: "400",
    style: "light",
  },
];

export const FontMenu = ({ selectedFont, onSelectFont }) => {
  return (
    <div className="font-menu">
      {fontOptions2.map((font, index) => (
        <div
          key={index}
          className={`font-option ${
            selectedFont.id === font.id ? "selected" : ""
          }`}
          style={{
            fontFamily: font.family,
            fontWeight: font.weight,
            fontStyle: font.style || "normal",
          }}
          onClick={() => {
            selectedFont = font;
            onSelectFont(font);
          }}
        >
          Aa
        </div>
      ))}
    </div>
  );
};
export const DiarySliderSettings = {
  slidesPerView: 2,
  spaceBetween: 20,
  breakpoints: {
    480: {
      slidesPerView: 2,
    },
    600: {
      slidesPerView: 2,
    },
    750: {
      slidesPerView: 3,
    },
    1100: {
      slidesPerView: 3,
    },
  },
};
export const PricingPlanCarouselSetting = {
  spaceBetween: 20,
  breakpoints: {
    480: {
      slidesPerView: 1.1,
    },
    600: {
      slidesPerView: 2.1,
    },
    750: {
      slidesPerView: 3.1,
    },
    1100: {
      slidesPerView: 3.1,
    },
  },
};
export const ArcTestCarousel = {
  spaceBetween: 20,
  breakpoints: {
    480: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 1,
    },
    750: {
      slidesPerView: 1,
    },
    1100: {
      slidesPerView: 4,
    },
  },
};
export const RealReviewsSetting = {
  spaceBetween: 20,
  breakpoints: {
    480: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    750: {
      slidesPerView: 2,
    },
    1100: {
      slidesPerView: 2,
    },
  },
};

export const NewFormatDateToCustomString = (date) => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}+00`;

  return formattedDate;
};
export const stripeAppearance = {
  theme: "night",
  labels: "floating",
  variables: {
    colorPrimary: "#8850ff",
    colorBackground: "#070d36",
    colorText: "#ffffff",
    colorDanger: "#df1b41",
    fontFamily: "Red Hat Display, sans-serif",
  },
  rules: {
    /* '.TabLabel--selected': {
			color: '#ffffff',
		},
		'.TabIcon--selected': {
			fill: '#ffffff',
		},
		'.Input': {
			backgroundColor: 'rgba(255,255,255,0.05)',
			border: 'none',
			boxShadow: 'none',
		},
		'.Input:disabled': {
			backgroundColor: 'rgba(255,255,255,0.05)',
			border: 'none',
			boxShadow: 'none',
		},
		'.Tab': {
			backgroundColor: 'rgba(255,255,255,0.05)',
			border: 'none',
			boxShadow: 'none',
		},
		'.Dropdown': {
			backgroundColor: 'rgba(255,255,255,0.05)',
			border: 'none',
			boxShadow: 'none',
		},

		'.Block': {
			backgroundColor: 'rgba(255,255,255,0.05)',
			border: 'none',
			boxShadow: 'none',
		}, */
    ".CheckboxInput": {
      border: "1px solid #8850ff ",
    },
  },
};

export const showMessagePayment = (message, type) => {
  if (type === "success") {
    toast.success(message, toastobj);
  } else {
    toast.error(message, toastobj);
  }
};

export const alwaysTruePaths = [
  "/auth/addjournalentry",
  "/auth/addjournalgratitude",
  "/auth/myjournal",
  "/auth/journalsummary",
  "/auth/journalgoodhabit",
  "/auth/journalgoals",
  "/auth/journalsetting",
  "/seventhjournal",
  "/auth/journalresources",
];

export const alwaysFalsePaths = [
  // The paths for which darkMode to always be false
  "/seventharc",
  "/auth/startmaintest",
];

export const CheckPathReturnTheme = () => {
  const pathAfterAuth = new URL(window.location.href).pathname;
  const dispatch = useDispatch();
  let darkMode = true;

  if (alwaysTruePaths.includes(pathAfterAuth)) {
    // console.log("........384");
    darkMode =
      JSON.parse(localStorage.getItem("seventh_journal_theme")) !== null
        ? JSON.parse(localStorage.getItem("seventh_journal_theme"))
        : true;
  } else if (alwaysFalsePaths.includes(pathAfterAuth)) {
    // console.log("........390");
    darkMode = false;
  } else {
    // console.log("........393");
    darkMode = true;
  }
  dispatch(toggleTheme(darkMode));
};

//This is used to identify header
export const checkPathType = () => {
  const pathAfterAuth = new URL(window.location.href).pathname;
  if (alwaysTruePaths.includes(pathAfterAuth)) {
    return 1; //for SeventhJOURNAL
  } else if (alwaysFalsePaths.includes(pathAfterAuth)) {
    return 2; //for SeventhArc
  } else {
    return 3; //for SeventhSIGHT
  }
};

export const makeThreeAttempts = async (sub_id, user_id, token) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await getSubscriptionById(sub_id, user_id, token);

      // Check if the response status is success
      if (response.status === 200) {
        return response;
      } else {
        // If the status is not success, wait for 5 seconds before the next attempt
        await new Promise((resolve) => setTimeout(resolve, 5000));
      }
    } catch (error) {
      // If an error occurs, wait for 5 seconds before the next attempt
      await new Promise((resolve) => setTimeout(resolve, 5000));
    }
  }

  // If all three attempts fail, return false
  return false;
};

export const siteMapping = {
  1: "seventhjournal",
  2: "seventharc",
  3: "seventhsight",
};
export const calculateMaxHeight = (reviewList) => {
  let max = 0;

  reviewList.forEach((item) => {
    const container = document.createElement("div");
    container.innerHTML = `<div class="item hp-review-box">
                              <div class="hp-review-title">${item.name}</div>
                              <div class="hp-review-subtitle">${item?.role}</div>
                              <p>${item?.body}</p>
                            </div>`;

    document.body.appendChild(container);
    const height = container.offsetHeight;
    document.body.removeChild(container);

    if (height > max) {
      max = height;
    }
  });

  return max;
};
export const calculateParagraphHeight = (paragraph) => {
  let max = 0;
  const parentContainer = document.createElement("div");
  parentContainer.className = "col-md-6";
  const container = document.createElement("div");
  trimvalue(paragraph).forEach((item) => {
    const paragraphContainer = document.createElement("p");
    paragraphContainer.className = "mt-2 capitalfirstword";
    paragraphContainer.textContent = item;

    container.appendChild(paragraphContainer);

    document.body.appendChild(container);
  });
  // console.log(container);
  parentContainer.appendChild(container);

  // Append parent container to body
  document.body.appendChild(parentContainer);
  const height = container.offsetHeight;
  document.body.removeChild(parentContainer);

  if (height > max) {
    max = height;
  }
  // console.log(max);
  return max;
};
const emojiData = {
  neutral:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-neutral.png?t=2024-01-09T17%3A09%3A47.489Z",
  happy:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-happy.png",
  excited:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-excited.png?t=2024-01-09T15%3A50%3A39.506Z",
  courageous:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-courageous.png?t=2024-01-09T15%3A40%3A42.839Z",
  anxious:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-anxious.png?t=2024-01-09T15%3A33%3A23.125Z",
  scared:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-scared.png?t=2024-01-09T17%3A38%3A42.333Z",
  rejected:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-rejected.png?t=2024-01-09T17%3A23%3A13.129Z",
  angry:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-angry.png?t=2024-01-09T15%3A25%3A43.779Z",
  frustrated:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-frustrated.png",
  sad: "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-sad.png?t=2024-01-09T17%3A29%3A35.687Z",
  guilty:
    "https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-guilty.png",
};
export const CustomDot = ({ cx, cy, value, moodsData, index }) => {
  const dataPoint = value[1];
  let i = 0;
  // console.log(i++);
  const objectAtIndex = moodsData[index];
  const keysOfObjectAtIndex = Object.keys(objectAtIndex);

  const emojiImage = emojiData[objectAtIndex["emoji"]];

  return (
    <>
      <g>
        <line
          x1={cx}
          y1={cy + 12}
          x2={cx}
          y2={
            window.innerWidth > 600 ? cy + value[1] * 2.6 : cy + value[1] * 2.5
          }
          stroke="#fff"
          strokeWidth={2}
        />

        <text x={cx} y={cy} dy={0} textAnchor="middle"></text>
        <image
          x={cx - 12}
          y={cy - 12}
          width={24}
          height={24}
          href={emojiImage} // Access emoji using element.emoji
        />
      </g>
    </>
  );
};
export const CustomTick = ({ payload, x, y }) => (
  <g transform={`translate(${x},${y})`}>
    <text dy={24} textAnchor="middle" fill="#666">
      {payload.value}
    </text>
  </g>
);
/* const DreamTextComponent = ({ dreamText, highlightedWords }) => {
  // Define the common style for highlighted words
  const highlightStyle = { color: "#0CD5DC" };

  // console.log(dreamText);
  const splitPhraseIntoWords = (phrase) => phrase.split(/\s+/);

  //  const splitArray = (arr) => {
  //   return arr.map((item) => item.split(" "));
  // };

  // const subArrays = splitArray(highlightedWords);
  // console.log(subArrays); 

  const removePunctuation = (text) => text.replace(/[.,]/g, "");

  // Function to check if a word should be highlighted
  const shouldHighlight = (word) => {
    const lowerCaseWord = removePunctuation(word.toLowerCase());
    return highlightedWords.some((highlightedWord) => {
      const lowerCaseHighlightedWords = splitPhraseIntoWords(
        removePunctuation(highlightedWord.toLowerCase())
      );
      return lowerCaseHighlightedWords.includes(lowerCaseWord);
    });
  };

  // Function to render the dream text with highlighted words
  const renderDreamText = () => {
    const paragraphs = dreamText.split(/\n/);

    return paragraphs.map((paragraph, paragraphIndex) => {
      const words = paragraph.split(/\s+/);
      return (
        <p key={paragraphIndex}>
          {words.map((word, wordIndex) => (
            <span
              key={wordIndex}
              style={shouldHighlight(word) ? highlightStyle : {}}
            >
              {word}{" "}
            </span>
          ))}
        </p>
      );
    });
  };

  return <div>{renderDreamText()}</div>;
};

export default DreamTextComponent; */
